import { render } from "./DrawExercise.vue?vue&type=template&id=d2784d62&ts=true"
import script from "./DrawExercise.vue?vue&type=script&lang=ts"
export * from "./DrawExercise.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__